var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.pages),function(page,index){return _c('div',{key:index,staticClass:"vfm-item",attrs:{"href":_setup.getHref(page)},on:{"click":function($event){$event.preventDefault();return _setup.go(page.fullPath, page.external, page.openInNewTab)}}},[_vm._v(" "+_vm._s(page.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }